import { BaseApi } from '@/main/baseApi';
import { DMS_MODULE, NAME } from './constants';

class BulkInventoryAdjustmentsProvider extends BaseApi {
	async getDropdownListForWareHouse() {
		return this.fetch(`/${DMS_MODULE}/${NAME}/GetWarehousesOfLoggedInUser`);
	}

	async getWHListForUploadBulkInventoryDropDown() {
		return this.fetch(`/${DMS_MODULE}/${NAME}/GetWHListForUploadBulkInventoryDropDown`);
	}

	async exportPartsInventoryByWarehouse(warehouseId: number | null , warehouseName: string){
		return this.downloadXlsxReport(`/${DMS_MODULE}/${NAME}/ExportPartsInventoryByWarehouse?warehouseId=${warehouseId}&warehouseName=${warehouseName}`,'');
	}

	async exportBulkInventoryUserUploadedData(uploadedBulkInventoryId: number ){
		return this.downloadXlsxReport(`/${DMS_MODULE}/${NAME}/ExportBulkInventoryUserUploadedData?uploadedBulkInventoryId=${uploadedBulkInventoryId}`,'');
	}

	async exportBulkInventoryErrors(uploadedBulkInventoryId: number ){
		return this.downloadXlsxReport(`/${DMS_MODULE}/${NAME}/ExportBulkInventoryErrors?uploadedBulkInventoryId=${uploadedBulkInventoryId}`,'');
	}

	async getBulkInventoryErrors(uploadedBulkInventoryId: number) {
			return this.fetch(`/${DMS_MODULE}/${NAME}/GetBulkInventoryErrors?uploadedBulkInventoryId=${uploadedBulkInventoryId}`);
	}

	async deleteBulkUploadedPartsInventory(uploadedId: number | null)	{
		return this.fetch(`/${DMS_MODULE}/${NAME}/DeleteBulkUploadedPartsInventory?uploadedId=${uploadedId}`);
	}
	
	async submitBulkUploadedPartsInventoryForApproval(uploadedId: number | null)	{
		return this.fetch(`/${DMS_MODULE}/${NAME}/SubmitBulkUploadedPartsInventoryForApproval?uploadedId=${uploadedId}`);
	}
	
	uploadCorrectedInventory(fileList: any, warehouseId: null | number) {
			const filename=fileList.name;
			const file = new FormData();
			file.append('file', fileList.raw, fileList.name);
			return this.uploadMultipart(`/${DMS_MODULE}/${NAME}/UploadCorrectedInventory?warehouseId=${warehouseId}&fileName=${filename}`, file);
	}
}

export const apiProvider = new BulkInventoryAdjustmentsProvider(DMS_MODULE, NAME);
